import { Component } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NgIf, AsyncPipe } from '@angular/common';
import { MbIconComponent } from '../mb-icon/mb-icon.component';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AuthActions } from '../../../store/auth/auth.actions';
import { selectAuthUser } from '../../../store/auth/auth.selectors';
import { Observable } from 'rxjs';
import { User } from '../../../store/auth/auth.state';
import { FullNamePipe, PositionPipe, EmailPipe } from '../../../shared/pipes';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import {MbButtonComponent} from '../mb-button/mb-button.component';
import {TranslocoDirective} from '@jsverse/transloco';
import {citizenRouteNames} from '../../../pages/citizen/citizen.routes';

@Component({
  selector: 'app-user-profile',
  imports: [
    NzAvatarModule,
    NzIconModule,
    NgIf,
    NzDropDownModule,
    NzDividerModule,
    MbIconComponent,
    AsyncPipe,
    FullNamePipe,
    PositionPipe,
    EmailPipe,
    MbButtonComponent,
    TranslocoDirective,
  ],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent {
  user$: Observable<User | null>;
  userType = localStorage.getItem('userType');
  isStaff = this.userType === 'STAFF' || this.userType === 'SUPER_ADMIN' || this.userType === 'ADMIN';

  constructor(private store: Store, private router: Router) {
    this.user$ = this.store.select(selectAuthUser);
  }

  onLogout(): void {
    localStorage.clear()
    window.location.reload()
  }

  onProfileClick(): void {
    if (this.isStaff) {
      this.router.navigate([citizenRouteNames.settings]);
    } else {
      this.router.navigate([citizenRouteNames.settings]);
    }
  }

  onSystemSettingsClick(): void {
    if (this.isStaff) {
      this.router.navigate([citizenRouteNames.settings], { fragment: 'system-config' });
    } else {
      this.router.navigate([citizenRouteNames.settings], { fragment: 'system-config' });
    }
  }

  navigateToLogin() {
    this.router.navigate([citizenRouteNames.auth]);
  }
  navigateToRegister() {
    this.router.navigate([citizenRouteNames.register]);
  }

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;
}
